import { render } from "./VedioViews.vue?vue&type=template&id=35d993c2&scoped=true"
import script from "./VedioViews.vue?vue&type=script&lang=js"
export * from "./VedioViews.vue?vue&type=script&lang=js"

import "./VedioViews.vue?vue&type=style&index=0&id=35d993c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d993c2"]])

export default __exports__